import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import banner1 from '../Projects/images/Classy-Necklaces.webp';
import banner2 from '../Projects/images/Diamond-Jewellery.webp';
import banner3 from '../Projects/images/Festive-Collections.webp';
import banner4 from '../Projects/images/Gold-bangle.webp';
import banner5 from '../Projects/images/Traditional-Necklaces.webp';
import banner6 from '../Projects/images/Trending-Collections.webp';


import './Projects.css';

function Projects() {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div id="rs-portfolio" className="bg42 pb-5 mb-3">
            <div className="project-container" style={{ width: '80%', margin: 'auto' }}>
                <div className="slider-part">
                    {/* Row 1: Static Image Display */}
                    <div className="image-row">
                        {[banner1, banner2, banner3].map((banner, index) => (
                            <div className="portfolio-wrap" key={`row1-${index}`}>
                                <div className="img-part">
                                    <img src={banner} className="images" alt={`Project ${index + 1}`} />
                                </div>
                                {/* Text below the image */}
                                <div className="text-box">
                                    {index === 0 && "Classy Necklaces"}
                                    {index === 1 && "Diamond Jewellery"}
                                    {index === 2 && "Festive Collections"}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Row 2: Static Image Display */}
                    <div className="image-row">
                        {[banner4, banner5, banner6].map((banner, index) => (
                            <div className="portfolio-wrap" key={`row2-${index}`}>
                                <div className="img-part">
                                    <img src={banner} className="images" alt={`Project ${index + 4}`} />
                                </div>
                                {/* Text below the image */}
                                <div className="text-box">
                                    {index === 0 && "Radiant Gold Bangle"}
                                    {index === 1 && "Traditional Necklaces"}
                                    {index === 2 && "Trending Collections"}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Projects;
